import React from "react";
import Box from "@mui/material/Box";
import { useTheme } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const PieChartDisplay = ({ data, currencyPrefix = "" }) => {
  const theme = useTheme();
  const themeColors = [ theme.palette.secondary.main, theme.palette.tertiary.main, theme.palette.primary.main ];
  const pieData = Object.entries(data).map(([name, value], index) => ({
    label: name,
    value,
    color: themeColors[index % themeColors.length],
  }));
  const series = [
    {
      data: pieData,
      valueFormatter: (data) => `${currencyPrefix}${data.value.toLocaleString()}`,
      labelFormatter: (data) => `${data.label}: ${currencyPrefix}${data.value.toLocaleString()}`,
    },
  ];

  return (
    <Box sx={{ width: "100%" }}>
      <PieChart
        series={series}
        height={300}
        margin={{ bottom: 75, right: 0, left: 0 }}
        slotProps={{
          tooltip: { 
            enterTouchDelay: 0,
            leaveTouchDelay: 5000
          },
          legend: {
            direction: 'row',
            position: { vertical: 'bottom', horizontal: 'middle' },
            padding: 0,
            labelStyle: { fontSize: 14 },
            itemMarkWidth: 11,
            itemMarkHeight: 10,
          },
        }}
      />
    </Box>
  );
};

export default PieChartDisplay;
